import { render, staticRenderFns } from "./block-documents-success.vue?vue&type=template&id=17c3a548&scoped=true&lang=pug"
import script from "./block-documents-success.vue?vue&type=script&lang=js"
export * from "./block-documents-success.vue?vue&type=script&lang=js"
import style0 from "./block-documents-success.vue?vue&type=style&index=0&id=17c3a548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c3a548",
  null
  
)

export default component.exports